export default __webpack_public_path__ + "static/media/img-stacking-3-video.13206fa7.jpg";